import { ProfileType } from './types'
import { ThunkAction } from '../../store/types'
import * as actions from './actions'
import axios from 'axios'
import {
  handleErrorMessageAlert,
  handleSuccessMessageAlert
} from '../../components/UI/Alert'

export const putProfile = (user: ProfileType): ThunkAction => {
  return async dispatch => {
    dispatch(actions.putProfileRequest())
    console.log('user.profile', user.profile) // 2111111111
    delete user.profile.mobileNumber // = '2111111111'
    try {
      const resp = await axios.put('/profiles', { ...user.profile })
      dispatch(actions.putProfileSuccess(resp.data))
      if (resp.status && resp.status === 200) {
        handleSuccessMessageAlert('Your profile is successfully changed')
      }
    } catch (err) {
      let errorText = ''
      if (Array.isArray(err.response.data.errors)) {
        err.response.data.errors.map((item: string) => {
          errorText = errorText ? errorText + '/' + item : item
          return errorText
        })
      } else {
        errorText =
          err.response && err.response.data && err.response.data.errorMessage
      }
      if (errorText === '') {
        errorText = 'Please check input data!'
      }
      handleErrorMessageAlert(errorText)
      dispatch(actions.putProfileFail(err))
    }
  }
}

export const getProfile = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.getProfileRequest())

    try {
      const resp = await axios.get('/profiles')
      // console.log(resp)
      dispatch(actions.getProfileSuccess(resp.data))
    } catch (err) {
      handleErrorMessageAlert(
        err.response && err.response.data && err.response.data.errorMessage
      )
      dispatch(actions.getProfileFail(err))
    }
  }
}
